import AvatarPopup from './AvatarPopup';

export default AvatarPopup;
